import { Link } from 'react-router-dom';

import { TCopyConfig } from '../../../interfaces';

const ToyotaCopyConfig: DeepPartial<TCopyConfig> = {
  autoAddons: {
    towing_road_services: {
      modalContent: [
        'Towing & Road Service(s) is an optional coverage and pays for the cost of towing and other roadside services like a locksmith, flat tire changing, and battery jumpstart in the event your vehicle is disabled (subject to the Service Call conditions).',
        'Are you the owner of a new Toyota? Every new Toyota comes with ToyotaCare, a two-year maintenance and roadside assistance program that covers towing, battery jump-starts, lockout protection, and more. If your ToyotaCare has expired, you should consider purchasing this additional coverage.',
      ],
    },
    oem_parts: {
      modalContent:
        'This is an optional coverage that pays for Toyota Genuine Parts in the event that your vehicle is damaged in a covered loss.',
    },
  },
  coverage: {
    uninsuredMotoristPropertyDamage: {
      description: `Your bumper sticker might say 'don't hit me if you're uninsured' but it isn't actually protecting you against that. Don't worry, this coverage can help.`,
    },
  },
  supportEmail: 'support@tai.team',
  formDisclaimer: (
    <>
      By clicking &quot;PRICE IT FOR ME,&quot; you agree that we may use
      information from you and 3rd party sources (like your credit, claims
      and/or driving histories) to prepare your personalized quote. Don’t worry,
      getting your price will not affect your credit score. To learn more about
      our information practices, including how to access and correct your
      information, please review our <Link to="/privacy">Privacy Policy</Link>{' '}
      and <Link to="/privacy">Notice of Information Practices</Link>.
    </>
  ),
};

export default ToyotaCopyConfig;
